import { Grid, styled } from '../../../../base';
import {
    HEADER_WRAPPER_HEIGHT,
    FOOTER_WRAPPER_HEIGHT,
} from '../../JobApplicationEntity.styles';

export const StyledContainer = styled(Grid)(() => ({
    height: `calc(100% - ${HEADER_WRAPPER_HEIGHT + FOOTER_WRAPPER_HEIGHT}px)`,
}));

export const StyledEvaluatedSkillsSection = styled(Grid)(() => ({
    flex: '0 0 auto',
    height: '340px',
}));
